import React from 'react'
import ServiceCard from '../card/ServiceCard'
import './style.css'
import { Container } from 'react-bootstrap'

function MyServices() {
  
  return (
    <div className='services-section'>
      <Container>
        <ServiceCard />
      </Container>
    </div>
  )
}

export default MyServices